import type { SavedFlight } from '@shared/types';
import { formatTimeLabel } from '@/lib/formatting';

/** Compact saved-flight row for the calendar day list. */
export function SavedFlightEventRow({ flight }: { flight: SavedFlight }) {
  return (
    <article
      className="saved-flight-event"
      aria-label={`${flight.ident} ${flight.origin} to ${flight.destination}`}
    >
      <div className="saved-flight-event__ident">{flight.ident}</div>
      <div className="saved-flight-event__route">
        {flight.origin} → {flight.destination}
      </div>
      <div className="saved-flight-event__times">
        {formatTimeLabel(flight.scheduled_departure)} → {formatTimeLabel(flight.scheduled_arrival)}
      </div>
    </article>
  );
}
